import instance from "../api/instance";
import { logout } from "./sessionActions";

import { GET_QUESTIONS } from "../constants/constants";

export const getQuestions = () => {
  return (dispatch) => {
    return instance
      .get(`/security-question/all`)
      .then((response) => {
        dispatch({
          type: GET_QUESTIONS,
          questions: response.data.data,
        });
      })
      .catch((err) => {
        var statusCode = err.response.status;

        switch (statusCode) {
          case 401: // Deslogueamos porque el token es inválido
            dispatch(logout());
            break;
          case 500: // Deslogueamos porque el token es inválido
            dispatch(logout());
            break;
        }
      });
  };
};
